import Input from '../../../../components/Input/Input';
import messages from './Messages';
import Select from '../../../../components/Select';
import ClassFilePicker from './ClassFilePicker/ClassFilePicker';
import React from 'react';
import { CalendarField } from '../../../../components/MyDatePicker/CalendarField';
import cloneDeep from 'lodash/cloneDeep';
import Collapsible from '../../../../components/Collapsible/Collapsible';
import { PhaseReminder } from './RemindersList';
import { Card } from '../CompanyPermissionSchemes/styles';
import { PDPClass, Topic } from '../../../../store/pdp/types';
import Icon from '../../../../components/Icon/Icon';
import {
  ClassDocument,
  ClassPhaseProp,
  ICompany,
  ICompanyMember,
  ICompanyProviders,
  StageTagOffset,
} from '../../../../store/companies/companiesTypes';
import { ITagView } from '../../../../store/providers/providerTypes';
import {
  ISurveyItem,
  ISurveyView,
  ISurveyViewServer,
  SurveyType,
} from '../../../../store/survey/surveyTypes';
import i18n from '../../../../i18n';
import { IOption } from '../../../../components/Select/Select';
import { IUser } from '../../../../store/users/usersType';
import { getSurvey } from '../../../../api/SurveyApi';

interface IOwnProps {
  phaseInfo: ClassPhaseProp;
  updatePhase: (phaseInfo: ClassPhaseProp, clazz?: PDPClass) => void;
  company: ICompany;
  clazz?: PDPClass;
  hideAdvancedOptions?: boolean;
  topic?: Topic;
  tag: ITagView;
  isTemplate: boolean;
  classPhases: ITagView[];
  relatedProviders: ICompanyProviders;
  createProviderSurvey?: (item: ISurveyItem) => Promise<any>;
  companyMembers?: { [key: number]: ICompanyMember };
  updateSurvey?: (
    surveyData: ISurveyView,
    providerSurveyItemData: ISurveyItem
  ) => Promise<any>;
  isOpen?: boolean;
  users: { [key: number]: IUser };
  pdpId: number;
  fastSaveSurveyItemInPhase?: (
    classDocument: ClassDocument,
    phase: ClassPhaseProp
  ) => Promise<any>;
}

type IComponentProps = IOwnProps;
interface IComponentState {
  phase: ClassPhaseProp;
  collapsibleOpen: boolean;
}

const contentVisibleOptions = [
  { value: 'ForEver', label: messages.ForEver },
  { value: 'DuringPhase', label: messages.DuringPhase },
];
const SurveyTagFilterOptions = [
  { value: 'None', label: messages.None },
  { value: 'ClassAndPhase', label: messages.ClassAndPhase },
  { value: 'ClassAndPhaseAndStage', label: messages.ClassAndPhaseAndStage },
];
export const getSurveyFilterTags = (
  clazz: PDPClass,
  phaseInfo: ClassPhaseProp
) => {
  const phaseFilters = phaseInfo.surveyTagFilters || 'ClassAndPhase';
  switch (phaseFilters) {
    case 'None':
      return [];
    case 'ClassAndPhase':
      return [phaseInfo.phaseTagId, -clazz.id];
    case 'ClassAndPhaseAndStage':
      return [
        phaseInfo.phaseTagId,
        -clazz.id,
        phaseInfo.phaseStageId + StageTagOffset,
      ];
  }
};

export class ClassPhaseEditorClass extends React.Component<
  IComponentProps,
  IComponentState
> {
  addMissingProps = (phase: ClassPhaseProp) => {
    const ret = cloneDeep(phase);
    if (!ret.phaseStartDates) ret.phaseStartDates = {};
    if (!ret.phaseEndDates) ret.phaseEndDates = {};
    if (!ret.phaseDocuments) ret.phaseDocuments = [];
    return ret;
  };
  constructor(props: IComponentProps) {
    super(props);
    const phase = this.addMissingProps(props.phaseInfo);
    this.state = {
      phase: phase,
      collapsibleOpen: this.props.isTemplate,
    };
  }
  componentDidMount() {
    this.setState({ phase: this.addMissingProps(this.props.phaseInfo) });
  }
  componentDidUpdate(prevProps: IComponentProps) {
    if (prevProps.phaseInfo !== this.props.phaseInfo)
      this.setState({ phase: this.addMissingProps(this.props.phaseInfo) });
  }

  render() {
    const {
      // phaseInfo,
      updatePhase,
      tag,
      isTemplate,
      relatedProviders,
      createProviderSurvey,
      updateSurvey,
      clazz,
      topic,
      hideAdvancedOptions,
      company,
      fastSaveSurveyItemInPhase,
      companyMembers,
      pdpId,
      users,
    } = this.props;

    const editPermissionOptions: IOption[] = [
      ...Object.values(company.roles)
        .filter((it) => it.roleType !== 'InProject')
        .map((role) => ({
          label: role.displayName as string,
          value: `R${role.id}`,
        })),
      ...Object.values(companyMembers || {})?.map((member) => ({
        label: users?.[member.userId].name as string,
        value: `U${member.userId}`,
      })),
    ];

    const updatePhaseHere = (phase: ClassPhaseProp) => {
      this.setState({ phase }, () => {
        updatePhase(this.state.phase);
      });
    };
    const update = (
      classDocument: ClassDocument,
      action: 'add' | 'remove' | 'update',
      currentItems: ClassDocument[],
      index?: number
    ) => {
      let result: any;
      if (action === 'remove') {
        result = currentItems.filter((it) =>
          it.providerItemId
            ? it.providerItemId !== classDocument.providerItemId
            : it.content !== classDocument.content
        );
      } else if (action === 'add') {
        result = [...currentItems, classDocument];
      } else {
        result = [...currentItems];
        if (index! >= 0) result[index!] = classDocument;
      }
      const res2 = cloneDeep(this.state.phase);
      const phaseInfo1 = { ...res2, phaseDocuments: result };
      updatePhaseHere(phaseInfo1);
    };

    const createQuizSurvey = async (
      name: string,
      type: SurveyType = 'Exam',
      useQuestionBank: boolean = false
    ) => {
      if (
        !createProviderSurvey ||
        !updateSurvey ||
        !fastSaveSurveyItemInPhase ||
        !clazz ||
        !topic
      )
        return;
      return createProviderSurvey({
        preserveParentEditLimitation: true,
        type: 'survey',
        dadId: clazz.properties.classDocumentHomeId,
        id: undefined as any,
        name: name,
        providerId: company.pdpPanels.find((el) => el.id === pdpId)!.properties
          .classProviderId,
        hidden: false,
        instanceType: 'User',
      } as ISurveyItem).then((data) => {
        const surveyItem = data?.payload?.remoteItem as ISurveyItem;
        const surveyData = {} as ISurveyView;
        surveyData.id = surveyItem?.surveyId;
        surveyData.name = surveyItem?.name;
        surveyData.surveyType = type;
        surveyData.visibilityStrategy = 'personal';
        surveyData.periodType = 'none';
        surveyData.keepUnique = true;
        surveyData.uniquePerTags = true;
        surveyData.uniquePerInstance = true;
        surveyData.keepSubmitQuestionList = true;
        surveyData.randomizeOrder = type === 'Exam';
        surveyData.autoLock = true;
        surveyData.showResponseToTarget = true;
        surveyData.offerToFillAtFirst = true;
        surveyData.fields = [
          { name: 'conf_allowDraft', value: 'false' },
          { name: 'conf_openHints', value: 'true' },
        ];
        if (useQuestionBank && topic.questionBankSurvey) {
          return getSurvey(topic.questionBankSurvey!.fillToken).then(
            (result) => {
              surveyData['surveyQuestionList'] = (
                result.data as ISurveyViewServer
              ).surveyQuestionList;
              return this.updateSurveyData(
                updateSurvey,
                surveyData,
                surveyItem,
                fastSaveSurveyItemInPhase
              );
            }
          );
        } else
          return this.updateSurveyData(
            updateSurvey,
            surveyData,
            surveyItem,
            fastSaveSurveyItemInPhase
          );
      });
    };
    const getClassFilePicker = () => {
      return (
        <ClassFilePicker
          inCollapsible={true}
          editable={true}
          items={this.state.phase.phaseDocuments}
          onRemove={(classDocument: ClassDocument) => {
            update(classDocument, 'remove', this.state.phase.phaseDocuments);
          }}
          onSave={(classDocument: ClassDocument, index: number) => {
            update(
              classDocument,
              index >= 0 ? 'update' : 'add',
              this.state.phase.phaseDocuments,
              index
            );
          }}
          clazz={clazz}
          createQuizSurvey={
            createProviderSurvey && updateSurvey ? createQuizSurvey : undefined
          }
          providers={relatedProviders}
          surveyFilterTags={
            clazz ? getSurveyFilterTags(clazz, this.props.phaseInfo) : []
          }
          showCorrectAnswers={true}
          topic={topic}
          phase={this.state.phase}
        />
      );
    };

    return (
      <>
        <Collapsible
          nested={true}
          customHeaderStyle={{ width: '100%' }}
          noZ={true}
          hideChevron={true}
          isOpen={this.props.isOpen}
          header={
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <div>{tag.text}</div>
              <Input
                id={this.state.phase.phaseTagId + 'disabled'}
                type="checkbox"
                checked={!this.state.phase.disabled}
                label={
                  i18n.t('enabledPhase', { ns: 'companyManagement' }) as string
                }
                onChange={(e) => {
                  const res = cloneDeep(this.state.phase);
                  res.disabled = !e.target.checked;
                  if (!res.disabled) this.setState({ collapsibleOpen: true });
                  updatePhaseHere(res);
                }}
              />
            </div>
          }
          onClose={() => {
            this.setState({ collapsibleOpen: false });
          }}
          onOpen={() => {
            this.setState({ collapsibleOpen: true });
          }}
        >
          {
            <div>
              <div>
                <Select
                  // id={}
                  label={messages.roleUserEditingPermission}
                  options={editPermissionOptions}
                  onChangeValues={(values: IOption[]) => {
                    const res = cloneDeep(this.state.phase);
                    res.adminUsers = values.map((item) => item.value as string);
                    updatePhaseHere(res);
                  }}
                  values={editPermissionOptions.filter((item) =>
                    this.state.phase.adminUsers?.includes(item.value as string)
                  )}
                  multiChoice={true}
                />
              </div>
              {!hideAdvancedOptions && (
                <Select
                  values={contentVisibleOptions.filter(
                    (it) => it.value === this.state.phase.contentVisible
                  )}
                  options={contentVisibleOptions}
                  onChangeValues={(values) => {
                    const res = cloneDeep(this.state.phase);
                    res.contentVisible = values[0]?.value.toString() as any;
                    updatePhaseHere(res);
                  }}
                  placeholder={
                    i18n.t('default', { ns: 'companyManagement' }) as string
                  }
                  label={
                    i18n.t('contentVisible', {
                      ns: 'companyManagement',
                    }) as string
                  }
                />
              )}
              {!isTemplate && (
                <Collapsible
                  header={
                    <span>
                      <Icon
                        type={'calendar'}
                        style={{ marginInlineEnd: '10px' }}
                      />
                      {i18n.t('timing', { ns: 'companyManagement' }) as string}
                    </span>
                  }
                  defaultOpen={true}
                >
                  {clazz?.properties?.classGroups?.map((group) => {
                    const groupKey = group.key;
                    return (
                      <Card
                        key={groupKey}
                        style={{
                          gap: '10px',
                          flexDirection: 'row',
                          alignItems: 'center',
                          overflowX: 'auto',
                        }}
                      >
                        <span style={{ flexGrow: 1 }}>{group.title}</span>
                        <CalendarField
                          value={
                            (this.state.phase.phaseStartDates[groupKey] &&
                              Number(
                                this.state.phase.phaseStartDates[groupKey]
                              )) ||
                            undefined
                          }
                          onChange={(value: number | null) => {
                            const res = cloneDeep(this.state.phase);
                            const oldStartDate = res.phaseStartDates[groupKey];
                            res.phaseStartDates[groupKey] = value!;
                            if (
                              !res.phaseEndDates[groupKey] ||
                              res.phaseStartDates[groupKey]! >
                                res.phaseEndDates[groupKey]!
                            )
                              if (oldStartDate)
                                res.phaseEndDates[groupKey]! +=
                                  res.phaseStartDates[groupKey]! - oldStartDate;
                              else
                                res.phaseEndDates[groupKey] =
                                  res.phaseStartDates[groupKey]! +
                                  60 * 60 * 1000;
                            updatePhaseHere(res);
                          }}
                          placeholder={
                            i18n.t('startDate', {
                              ns: 'companyManagement',
                            }) as string
                          }
                          withTime={true}
                          // label={messages.startDate}
                        />
                        <span>
                          {
                            i18n.t('until', {
                              ns: 'companyManagement',
                            }) as string
                          }
                        </span>
                        <CalendarField
                          value={
                            (this.state.phase.phaseEndDates[groupKey] &&
                              Number(
                                this.state.phase.phaseEndDates[groupKey]
                              )) ||
                            undefined
                          }
                          onChange={(value: number | null) => {
                            const res = cloneDeep(this.state.phase);
                            res.phaseEndDates[groupKey] = value!;
                            if (
                              res.phaseStartDates[groupKey] &&
                              res.phaseStartDates[groupKey]! >
                                res.phaseEndDates[groupKey]!
                            )
                              res.phaseEndDates[groupKey] =
                                res.phaseStartDates[groupKey]! + 60 * 60 * 1000;
                            updatePhaseHere(res);
                          }}
                          placeholder={
                            i18n.t('endDate', {
                              ns: 'companyManagement',
                            }) as string
                          }
                          min={
                            this.state.phase.phaseStartDates[groupKey]
                              ? this.state.phase.phaseStartDates[groupKey]! -
                                24 * 60 * 60 * 1000 +
                                1
                              : undefined
                          }
                          withTime={true}
                          // label={messages.endDate}
                        />
                      </Card>
                    );
                  })}
                </Collapsible>
              )}
              {!hideAdvancedOptions && (
                <Card
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    flexGap: '0.5rem',
                  }}
                  className={'row'}
                >
                  <Input
                    wrapperClassName={'col s12 m6 l6'}
                    type="checkbox"
                    wrapperStyle={{}}
                    checked={this.state.phase.showCorrectAnswers || false}
                    onChange={(e) => {
                      const res = cloneDeep(this.state.phase);
                      res.showCorrectAnswers = e.target.checked;
                      updatePhaseHere(res);
                    }}
                    id={'showCorrectAnswers' + this.state.phase.phaseTagId}
                    label={
                      i18n.t('showCorrectAnswers', {
                        ns: 'companyManagement',
                      }) as string
                    }
                  />
                  <Input
                    wrapperClassName={'col s12 m6 l6'}
                    type="checkbox"
                    wrapperStyle={{}}
                    checked={
                      this.state.phase.limitViewToPresentMembers || false
                    }
                    onChange={(e) => {
                      const res = cloneDeep(this.state.phase);
                      res.limitViewToPresentMembers = e.target.checked;
                      updatePhaseHere(res);
                    }}
                    id={'pres' + this.state.phase.phaseTagId}
                    label={
                      i18n.t('limitViewToPresentMembers', {
                        ns: 'companyManagement',
                      }) as string
                    }
                  />
                  {isTemplate && (
                    <Input
                      wrapperClassName={'col s12 m6 l6'}
                      type="checkbox"
                      wrapperStyle={{}}
                      checked={this.state.phase.limitStateToOne || false}
                      onChange={(e) => {
                        const res = cloneDeep(this.state.phase);
                        res.limitStateToOne = e.target.checked;
                        updatePhaseHere(res);
                      }}
                      id={'limit' + this.state.phase.phaseTagId}
                      label={
                        i18n.t('limitStateToOne', {
                          ns: 'companyManagement',
                        }) as string
                      }
                    />
                  )}
                  {isTemplate && (
                    <Input
                      wrapperClassName={'col s12 m6 l6'}
                      type="checkbox"
                      wrapperStyle={{}}
                      checked={this.state.phase.includeInCorrective || false}
                      onChange={(e) => {
                        const res = cloneDeep(this.state.phase);
                        res.includeInCorrective = e.target.checked;
                        updatePhaseHere(res);
                      }}
                      id={'corrective' + this.state.phase.phaseTagId}
                      label={
                        i18n.t('includeInCorrective', {
                          ns: 'companyManagement',
                        }) as string
                      }
                    />
                  )}
                  {isTemplate && (
                    <Input
                      wrapperClassName={'col s12 m6 l6'}
                      type="checkbox"
                      wrapperStyle={{}}
                      checked={this.state.phase.phaseWithGrade || false}
                      onChange={(e) => {
                        const res = cloneDeep(this.state.phase);
                        res.phaseWithGrade = e.target.checked;
                        updatePhaseHere(res);
                      }}
                      id={'withGrade' + this.state.phase.phaseTagId}
                      label={
                        i18n.t('phaseWithGrade', {
                          ns: 'companyManagement',
                        }) as string
                      }
                    />
                  )}
                  <div className={'col s12 m6 l6'}>
                    {
                      <Select
                        values={this.props.classPhases
                          .map((it) => ({
                            value: it.id,
                            label: it.text,
                          }))
                          .filter(
                            (it) =>
                              it.value ===
                              this.state.phase.limitViewToFillSurveyForPart
                          )}
                        options={this.props.classPhases.map((it) => ({
                          value: it.id,
                          label: it.text,
                        }))}
                        onChangeValues={(values) => {
                          const res = cloneDeep(this.state.phase);
                          res.limitViewToFillSurveyForPart = values[0]
                            ?.value as number | undefined;
                          updatePhaseHere(res);
                        }}
                        label={
                          i18n.t('limitViewToFillSurveyForPart', {
                            ns: 'companyManagement',
                          }) as string
                        }
                      />
                    }
                  </div>
                  {isTemplate && (
                    <div className={'col s12 m6 l6'}>
                      <Select
                        values={SurveyTagFilterOptions.filter(
                          (it) => it.value === this.state.phase.surveyTagFilters
                        )}
                        allowRemove={false}
                        options={SurveyTagFilterOptions}
                        onChangeValues={(values) => {
                          const res = cloneDeep(this.state.phase);
                          res.surveyTagFilters =
                            values[0]?.value.toString() as any;
                          updatePhaseHere(res);
                        }}
                        label={
                          i18n.t('surveyTagFilterOptions', {
                            ns: 'companyManagement',
                          }) as string
                        }
                      />
                    </div>
                  )}
                </Card>
              )}
              <div>{getClassFilePicker()}</div>
              {!hideAdvancedOptions && (
                <PhaseReminder
                  phaseProps={this.state.phase}
                  updatePhase={updatePhaseHere}
                />
              )}
            </div>
          }{' '}
        </Collapsible>
      </>
    );
  }

  private updateSurveyData = (
    updateSurvey: (
      surveyData: ISurveyView,
      providerSurveyItemData: ISurveyItem
    ) => Promise<any>,
    surveyData: ISurveyView,
    surveyItem: ISurveyItem,
    fastSaveSurveyItemInPhase: (
      classDocument: ClassDocument,
      phase: ClassPhaseProp
    ) => Promise<any>
  ) => {
    return updateSurvey(surveyData, surveyItem).then(() => {
      return fastSaveSurveyItemInPhase!(
        {
          providerItemId: surveyItem.id,
          title: surveyItem.name,
          providerId: surveyItem.providerId,
          type: 'survey',
          surveyId: surveyItem.surveyId,
        },
        this.props.phaseInfo
      ).then(() => {
        return surveyItem;
      });
    });
  };
}
